// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__3Ffit","info":"Note_info__1d2LN","note":"Note_note__2Sfig","actions":"Note_actions__IUL-s"};